// Keep analytics calls behind one seam so components do not depend directly on
// Google Analytics. No personal form values are included in these events.
export function trackEvent(eventName, metadata = {}) {
  if (typeof window === "undefined") {
    return;
  }

  const event = { event: eventName, ...metadata };
  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, metadata);
  } else {
    window.dataLayer.push(event);
  }

  window.dispatchEvent(new CustomEvent("kettik:analytics", { detail: event }));
}
